import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { CmsModules, CmsModuleShape } from 'containers/CmsPage/CmsModules';

export const CmsLayout = ({ activateAt, direction, modules, pattern, hasGutter }) => {
  // Convert pattern to its css-valid equivalent
  const cssPattern = (pattern || '').replace(/:/g, '-');
  const layoutClasses = classNames({
    CmsLayout: true,
    [`CmsLayout--activate-at-${activateAt}`]: activateAt,
    [`CmsLayout--direction-${direction}`]: direction,
    [`CmsLayout--pattern-${cssPattern}`]: cssPattern,
    'CmsLayout--with-gutter': hasGutter,
  });

  return (
    <div className={layoutClasses}>
      <CmsModules modules={modules} />
    </div>
  );
};

CmsLayout.propTypes = {
  activateAt: PropTypes.oneOf(['phone', 'tablet', 'desktop']),
  direction: PropTypes.oneOf(['left-to-right', 'right-to-left']),
  modules: PropTypes.arrayOf(CmsModuleShape).isRequired,
  pattern: PropTypes.oneOf(['1', '1:1', '1:2', '2:1', 'phone:1', '1:phone']),
  hasGutter: PropTypes.bool,
};
